import arrowRight from 'assets/arrow-right.svg'

interface NavButtonProp {
    title: string
    onClick: () => void
    active: boolean
}

const NavButton = ({title, onClick, active}: NavButtonProp) => {
    return (
        <button
            className="relative border-none bg-yellow-40 py-10 px-24"
            onClick={onClick}
        >
            {title}
            {active && (
                <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/2 rounded-r-[60px] bg-yellow-40 px-[21.5px] py-[45px]">
                    <img src={arrowRight} alt="signin" />
                </div>
            )}
        </button>
    )
}

export default NavButton
